import { DEFAULT_ARCHIVE_AFTER_DAYS } from './completion-settings';

/** When an invoice counts as completed, and whether and when completing it archives it. */
export interface InvoiceCompletionSettings {
  readonly isApprovalRequired: boolean;
  readonly isPaymentRequired: boolean;
  readonly isPostingRequired: boolean;
  readonly isArchivingOnCompletion: boolean;
  /** Days after completion it is archived; 0 archives in the completing write. */
  readonly archiveAfterDays: number;
}

/** What the completion settings check on one invoice. */
export interface InvoiceCompletionFacts {
  /** The invoice is `APPROVED`. */
  readonly isApproved: boolean;
  /** The invoice is fully `PAID`. */
  readonly isPaid: boolean;
  /** The ERP reports the invoice as `POSTED`. */
  readonly isPosted: boolean;
}

export const DEFAULT_INVOICE_COMPLETION: InvoiceCompletionSettings = {
  isApprovalRequired: true,
  isPaymentRequired: true,
  isPostingRequired: false,
  isArchivingOnCompletion: true,
  archiveAfterDays: DEFAULT_ARCHIVE_AFTER_DAYS
};

/** Default of an account's `isLinkedSupplierRequired`: approval does not need a linked supplier. */
export const DEFAULT_IS_LINKED_SUPPLIER_REQUIRED = false;

/** Whether every checked condition holds; with nothing checked an invoice never completes. */
export function meetsInvoiceCompletion(
  settings: InvoiceCompletionSettings,
  facts: InvoiceCompletionFacts
): boolean {
  if (!settings.isApprovalRequired && !settings.isPaymentRequired && !settings.isPostingRequired) {
    return false;
  }
  return (
    (!settings.isApprovalRequired || facts.isApproved) &&
    (!settings.isPaymentRequired || facts.isPaid) &&
    (!settings.isPostingRequired || facts.isPosted)
  );
}
